import { produce } from 'immer';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import {
  ADD_WISHLIST_ITEMS_TO_CART,
  ADD_WISHLIST_ITEMS_TO_CART_FULFILLED,
  ADD_WISHLIST_ITEMS_TO_CART_REJECTED,
  CLEAR_ACCOUNT_WISHLIST,
  CLEAR_ADD_WISHLIST_ITEMS_TO_CART,
  CLEAR_CLONE_WISHLIST,
  CLONE_WISHLIST,
  CLONE_WISHLIST_FULFILLED,
  CLONE_WISHLIST_REJECTED,
  FETCH_WISHLIST,
  FETCH_WISHLIST_FULFILLED,
  FETCH_WISHLIST_REJECTED,
  REMOVE_WISHLIST_ITEMS,
  REMOVE_WISHLIST_ITEMS_FULFILLED,
  REMOVE_WISHLIST_ITEMS_REJECTED,
} from './actionTypes';
import { WishlistAction, WishlistState } from './types';

const initialState: WishlistState = {
  addItemsToCart: RemoteRecordData.getDefault(),
  cloneWishlist: RemoteRecordData.getDefault(),
  removeWishlistItems: RemoteRecordData.getDefault(),
  wishlists: {},
};

const reducer = (
  state: WishlistState = initialState,
  action: WishlistAction,
): WishlistState => {
  switch (action.type) {
    case ADD_WISHLIST_ITEMS_TO_CART:
      return produce(state, (draft: WishlistState) => {
        draft.addItemsToCart = RemoteRecordData.init();
      });

    case ADD_WISHLIST_ITEMS_TO_CART_FULFILLED:
      return produce(state, (draft: WishlistState) => {
        draft.addItemsToCart = RemoteRecordData.fulfill(action.payload.data);
      });

    case ADD_WISHLIST_ITEMS_TO_CART_REJECTED:
      return produce(state, (draft: WishlistState) => {
        draft.addItemsToCart = RemoteRecordData.reject(action.payload.error);
      });

    case CLEAR_ADD_WISHLIST_ITEMS_TO_CART:
      return produce(state, (draft: WishlistState) => {
        draft.addItemsToCart = initialState.addItemsToCart;
      });

    case CLEAR_CLONE_WISHLIST:
      return produce(state, (draft: WishlistState) => {
        draft.cloneWishlist = initialState.cloneWishlist;
      });

    case CLONE_WISHLIST:
      return produce(state, (draft: WishlistState) => {
        draft.cloneWishlist = RemoteRecordData.init();
      });

    case CLONE_WISHLIST_FULFILLED:
      return produce(state, (draft: WishlistState) => {
        draft.cloneWishlist = RemoteRecordData.fulfill(action.payload.data);
      });

    case CLONE_WISHLIST_REJECTED:
      return produce(state, (draft: WishlistState) => {
        draft.cloneWishlist = RemoteRecordData.reject(action.payload.error);
      });

    case FETCH_WISHLIST:
      return produce(state, (draft: WishlistState) => {
        draft.wishlists[action.payload.wishlistId] = Object.assign(
          RemoteRecordData.init(),
          {
            data: draft.wishlists[action.payload.wishlistId]
              ? draft.wishlists[action.payload.wishlistId]?.data
              : undefined,
          },
        );
      });

    case FETCH_WISHLIST_FULFILLED:
      return produce(state, (draft: WishlistState) => {
        draft.wishlists[action.payload.wishlistId] = RemoteRecordData.fulfill(
          action.payload.data,
        );
      });

    case FETCH_WISHLIST_REJECTED:
      return produce(state, (draft: WishlistState) => {
        draft.wishlists[action.payload.wishlistId] = RemoteRecordData.reject(
          action.payload.error,
        );
      });

    case REMOVE_WISHLIST_ITEMS:
      return produce(state, (draft: WishlistState) => {
        draft.removeWishlistItems = RemoteRecordData.init();
      });

    case REMOVE_WISHLIST_ITEMS_FULFILLED:
      return produce(state, (draft: WishlistState) => {
        draft.removeWishlistItems = RemoteRecordData.fulfill({});
      });

    case REMOVE_WISHLIST_ITEMS_REJECTED:
      return produce(state, (draft: WishlistState) => {
        draft.removeWishlistItems = RemoteRecordData.reject(
          action.payload.error,
        );
      });

    case CLEAR_ACCOUNT_WISHLIST:
      return initialState;

    default:
      return state;
  }
};

export {
  reducer,
};
